module.exports = __webpack_public_path__ + "img/html.1a44baca.png";